export default function({ dispatch }, params) {
    // POST /auth/add/email
    return dispatch('post', {
        url: '/auth/patch/email',
        data: params
    }, {
        root: true
    })
    .then((response) => {
        return response
    })
    .catch((error) => {
        return error
    })
}